module.exports = __webpack_public_path__ + "static/media/icon-get-paid.b723942e.svg";